export enum ContactType {
  Accounting = 'ACCOUNTING',
  Shipping = 'SHIPPING',
  Purchasing = 'PURCHASING',
}

export const CONTACT_TYPE_LABEL: Record<ContactType, string> = {
  [ContactType.Accounting]: 'Accounting',
  [ContactType.Purchasing]: 'Purchasing',
  [ContactType.Shipping]: 'Shipping',
};
